// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".del_pop.report{text-align:center}.del_pop.report .el-dialog__footer{text-align:center;border-top:1px solid #e9e9e9}.del_pop.report .el-dialog__footer .fix-btn{width:100px}", ""]);
// Exports
module.exports = exports;
